<template>
    <div class="hot">
        <Condtion
            tableWidth="auto"
            :productList="productList"
            @handleCurrentChange="handleCurrentChange"
        ></Condtion>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import * as apis from '../fetch/common';

import Condtion from '../components/search/Condtion';

export default {
    name: 'hot',
    components: {
        Condtion,
    },
    computed: {
        type() {
            return this.$route.params.type || '1';
        },
    },
    data() {
        return {
            productList: {},
            title: {
                '1': '特价产品',
                '2': '促销产品',
            },
        };
    },
    methods: {
        ...mapActions(['setBreadcrumb']),
        getProductList(page = 1) {
            apis.getProductList(this.type, page, 12).then(res => {
                this.setBreadcrumb(this.title[this.type]);
                const list = res.list && res.list.map(r => ({ ...r, shopNum: 1 }));
                this.productList = { ...res, list };
            });
        },
        handleCurrentChange(page) {
            this.getProductList(page);
        },
    },
    watch: {
        $route(val) {
            this.getProductList();
            this.productList = [];
        },
    },
    mounted() {
        this.getProductList();
    },
};
</script>

<style lang="less" scoped>
</style>